import React, { useState, useEffect } from 'react';
import {
  Paper,
  Typography,
  Button,
  Box,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  TextField,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Collapse,
  IconButton,
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import apiService from '../../../../componentes/actions/services';
import { useSelector } from 'react-redux';
import BitacoraTable from '../../../view/sala_venta/reportes/BitacoraTable';
import '../../../style/bitacoraStyles.css';
import { RepeatOneSharp } from '@mui/icons-material';

const FacturasPendientes = () => {
  const { user } = useSelector(state => state.auth);
  const [jsonData, setJsonData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [fechaIni, setFechaIni] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [expandedStore, setExpandedStore] = useState(null);
  const [expandedDate, setExpandedDate] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [validating, setValidating] = useState(false);
  const [processResults, setProcessResults] = useState([]);
  const [trackingId, setTrackingId] = useState(null);
  const [pollingInterval, setPollingInterval] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});
  const [batchStatus, setBatchStatus] = useState(null);
  const [bitacoraData, setBitacoraData] = useState([]);
  const [bitacoraLoading, setBitacoraLoading] = useState(false);
  const [pollingCount, setPollingCount] = useState(0);
  const [lastBitacoraResult, setLastBitacoraResult] = useState(null);
  const [pendingGuides, setPendingGuides] = useState([]);
  const [currentGuideIndex, setCurrentGuideIndex] = useState(0);
  const [nextExecutionTime, setNextExecutionTime] = useState(0);
  const [maxSelectionAlert, setMaxSelectionAlert] = useState(false);
  const [duplicateAlert, setDuplicateAlert] = useState(false);
  const [showProcessingAlert, setShowProcessingAlert] = useState(false);

  useEffect(() => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
    const currentDay = today.toISOString().split('T')[0];
    
    setFechaIni(firstDayOfMonth);
    setFechaFin(currentDay);
    fetchInitialData(firstDayOfMonth, currentDay);

    // Configurar recarga automática cada 15 minutos
    const reloadTimer = setTimeout(() => {
      window.location.reload();
    }, 15 * 60 * 1000); // 15 minutos

    return () => {
      if (pollingInterval) {
        clearInterval(pollingInterval);
      }
      clearTimeout(reloadTimer);
    };
  }, []);

  // Efecto para el contador regresivo
  useEffect(() => {
    let countdownInterval;
    
    if (nextExecutionTime > 0) {
      countdownInterval = setInterval(() => {
        setNextExecutionTime(prev => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (countdownInterval) {
        clearInterval(countdownInterval);
      }
    };
  }, [nextExecutionTime]);

  const fetchInitialData = async (startDate, endDate) => {
    try {
      setLoading(true);
      const structura = ({FechaIni: startDate,FechaFin: endDate})
      const response = await apiService.get('ObtenerFacturasPendientesPorFecha',structura,user);
      const data = response; 
      setJsonData(data);
      setError(null);
      setExpandedStore(null);
      setExpandedDate(null);
      setSelectedItems([]);
      setMaxSelectionAlert(false);
      setDuplicateAlert(false);
    } catch (error) {
      console.error("Error al obtener datos:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    await fetchInitialData(fechaIni, fechaFin);
  };

  // Función para verificar si una factura ya existe en la lista seleccionada
  const isDuplicate = (item, itemsList) => {
    return itemsList.some(selected => 
      selected.DocNum === item.DocNum && 
      selected.Establecimiento === item.Establecimiento
    );
  };

  // Función CORREGIDA para verificar si un item tiene error en blanco
  const hasNoError = (item) => {
    // Verificar si ErrorMsg existe y no está vacío o solo tiene espacios
    return !item.ErrorMsg || item.ErrorMsg.toString().trim() === '';
  };

  const handleSelectItem = (item) => {
    // No permitir seleccionar facturas del día actual o con error
    const itemDate = new Date(item.DocDate || item.fecha);
    const today = new Date();
    if (itemDate.toDateString() === today.toDateString() || !hasNoError(item)) {
      return;
    }
    
    // Verificar si es un duplicado
    if (isDuplicate(item, selectedItems) && !selectedItems.some(selected => selected.TransId === item.TransId)) {
      setDuplicateAlert(true);
      setTimeout(() => setDuplicateAlert(false), 3000);
      return;
    }
    
    setSelectedItems(prev =>
      prev.some(selected => selected.TransId === item.TransId)
        ? prev.filter(selected => selected.TransId !== item.TransId)
        : [...prev, item]
    );
  };
  
  const handleToggleAllGroupItems = (items) => {
    // Filtrar items que no son del día actual y que no tienen error
    const today = new Date();
    const filteredItems = items.filter(item => {
      const itemDate = new Date(item.DocDate || item.fecha);
      return itemDate.toDateString() !== today.toDateString() && hasNoError(item);
    });

    const allSelected = filteredItems.every(item => 
      selectedItems.some(selected => selected.TransId === item.TransId)
    );
    
    if (allSelected) {
      setSelectedItems(prev => 
        prev.filter(selected => 
          !filteredItems.some(item => item.TransId === selected.TransId)
        )
      );
    } else {
      // Filtrar solo los items que no son duplicados
      const nonDuplicateItems = filteredItems.filter(item => 
        !selectedItems.some(selected => 
          selected.DocNum === item.DocNum && 
          selected.Establecimiento === item.Establecimiento
        )
      );
      
      const newSelected = [
        ...selectedItems,
        ...nonDuplicateItems.filter(item => 
          !selectedItems.some(selected => selected.TransId === item.TransId)
        )
      ];
      setSelectedItems(newSelected);
    }
  };

  const handleSelectAll = (groups) => {
    const today = new Date();
    const allItems = groups.flatMap(store => 
      store.dates.flatMap(dateGroup => 
        dateGroup.Detalle.filter(item => {
          const itemDate = new Date(item.DocDate || item.fecha);
          return itemDate.toDateString() !== today.toDateString() && hasNoError(item);
        })
      )
    );
    
    // Eliminar duplicados (mismo DocNum y Establecimiento)
    const uniqueItems = allItems.reduce((acc, current) => {
      const isDuplicate = acc.some(item => 
        item.DocNum === current.DocNum && 
        item.Establecimiento === current.Establecimiento
      );
      if (!isDuplicate) {
        acc.push(current);
      }
      return acc;
    }, []);
    
    const allSelected = uniqueItems.every(item => 
      selectedItems.some(selected => selected.TransId === item.TransId)
    );

    if (allSelected) {
      setSelectedItems([]);
    } else {
      setSelectedItems(uniqueItems);
    }
  };

  const parseBatchResponse = (responseData) => {
    try {
      if (!responseData || responseData.datos_Generados === '') {
        return [];
      }
  
      const datosGenerados = JSON.parse(responseData.datos_Generados);
      
      if (!datosGenerados.Resultados) return [];

      return datosGenerados.Resultados.map(item => {
        const tipo = item.TipoMensaje?.toUpperCase() || '';
        const isError = tipo.includes('ERROR');
        const isWarning = tipo.includes('WARNING');
        const isSuccess = !isError && !isWarning;
        
        return {
          docNum: item.NumeroDocumento || '',
          docEntry: '', // No está en los datos de ejemplo
          establecimiento: '', // No está en los datos de ejemplo
          transId: '', // No está en los datos de ejemplo
          success: isSuccess,
          error: isError ? item.MensajeError : null,
          warning: isWarning,
          mensaje: item.MensajeError || (isSuccess ? 'Procesado correctamente' : ''),
          bitacora: [], // No hay datos de bitácora en el formato actual
          detalles: item.MensajeError ? item.MensajeError.split('|') : [],
          fecha: item.Fecha,
          tipoMensaje: item.TipoMensaje,
          numeroDocumento: item.NumeroDocumento
        };
      });
    } catch (e) {
      console.error('Error parsing batch response:', e);
      return [];
    }
  };

  const checkIfResultsChanged = (newResults) => {
    if (!lastBitacoraResult || newResults.length !== lastBitacoraResult.length) {
      return true;
    }

    // Comparar cada resultado individualmente
    return newResults.some((result, index) => {
      const lastResult = lastBitacoraResult[index];
      return result.tipoMensaje !== lastResult.tipoMensaje || 
             result.mensaje !== lastResult.mensaje ||
             result.success !== lastResult.success;
    });
  };

  const fetchBitacoraData = async (guideId) => {
    try {
      setBitacoraLoading(true);
      const structura3 = ({ Guide: guideId });
      const result = await apiService.get('ObtenerListaBitacora', structura3, user);
      const parsedResults = parseBatchResponse(result);
      
      // Verificar si los resultados cambiaron
      const resultsChanged = checkIfResultsChanged(parsedResults);
      
      if (resultsChanged) {
        setPollingCount(0);
        setBitacoraData(parsedResults);
        setLastBitacoraResult(parsedResults);
        setProcessResults(parsedResults); // Actualizar también processResults
      } else {
        setPollingCount(prev => prev + 1);
      }

      const allCompleted = parsedResults.every(item => item.success || item.error);
      if (allCompleted) {
        if (pollingInterval) {
          clearInterval(pollingInterval);
          setPollingInterval(null);
        }
        setProcessing(false);
        setBatchStatus('completed');
        setNextExecutionTime(0);
        return true; // Indicar que el procesamiento terminó
      }

      return false; // Indicar que el procesamiento continúa
    } catch (error) {
      console.error('Error en polling:', error);
      setPollingCount(prev => prev + 1);
      return false;
    } finally {
      setBitacoraLoading(false);
    }
  };

  const startPolling = (guideId) => {
    // Limpiar intervalo anterior si existe
    if (pollingInterval) {
      clearInterval(pollingInterval);
      setPollingInterval(null);
    }
    
    setPollingCount(0);
    setLastBitacoraResult(null);
    setPendingGuides([guideId]);
    setCurrentGuideIndex(0);
    setNextExecutionTime(10);
    setShowProcessingAlert(true);

    // Ejecutar inmediatamente la primera vez
    fetchBitacoraData(guideId);

    // Configurar intervalo cada 10 segundos
    const interval = setInterval(async () => {
      const isCompleted = await fetchBitacoraData(guideId);
      if (isCompleted) {
        clearInterval(interval);
        setPollingInterval(null);
      }
      setNextExecutionTime(10); // Reiniciar contador
    }, 10000);

    setPollingInterval(interval);
  };

  const handleReprocess = async () => {
    if (selectedItems.length === 0) {
      alert('Por favor seleccione al menos un item para reprocesar');
      return;
    }
    
    setProcessing(true);
    setProcessResults([]);
    setBatchStatus('processing');
    setPendingGuides([]);
    setCurrentGuideIndex(0);
    setBitacoraData([]);
    
    try {
      // Eliminar duplicados antes de enviar (por si acaso)
      const uniqueItems = selectedItems.reduce((acc, current) => {
        const isDuplicate = acc.some(item => 
          item.DocNum === current.DocNum && 
          item.Establecimiento === current.Establecimiento
        );
        if (!isDuplicate) {
          acc.push(current);
        }
        return acc;
      }, []);
      
      const structura4 = { Facturas: uniqueItems.map(item => ({
        Establecimiento: item.Establecimiento,
        DocEntry: item.DocEntryFact,
        DocNum: item.DocNum,
        CostCode2: item.Dimension2,
        TransId: item.TransId
      }))}
      
      const result = await apiService.post('ProcesarFacturasReservaBatch', structura4);
      const guideId = result.datos_Generados;
      
      if (!guideId) {
        throw new Error('No se recibió el Guide ID del servidor');
      }
      
      setTrackingId(guideId);
      startPolling(guideId);
      
    } catch (error) {
      console.error('Error en el proceso general:', error);
      alert('Ocurrió un error durante el procesamiento: ' + error.message);
      setProcessing(false);
      setBatchStatus('error');
      setNextExecutionTime(0);
    }
  };

  const handleValidateStock = async () => {
    setValidating(true);

    try {
      const result = await apiService.post('ValidarDetalleFactura');
      const datosGenerados = result.datos_Generados || '';
      alert(`Validación completada: ${datosGenerados}`);
      await fetchData();
    } catch (error) {
      console.error('Error validando existencias:', error);
      alert('Ocurrió un error durante la validación: ' + error.message);
    } finally {
      setValidating(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES');
  };

  const handleStoreAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedStore(isExpanded ? panel : false);
  };

  const handleDateAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedDate(isExpanded ? panel : false);
  };

  const toggleRowExpand = (docNum) => {
    setExpandedRows(prev => ({
      ...prev,
      [docNum]: !prev[docNum]
    }));
  };

  const groupByStoreAndDate = (data) => {
    const grouped = {};
    
    data.forEach(group => {
      const store = group.Sala;
      const date = group.DocDate;
      
      if (!grouped[store]) {
        grouped[store] = {
          storeName: store,
          totalDocs: 0,
          dates: {}
        };
      }
      
      if (!grouped[store].dates[date]) {
        grouped[store].dates[date] = {
          date: date,
          Detalle: [],
          CantidadDoc: 0
        };
      }
      
      grouped[store].dates[date].Detalle.push(...group.Detalle);
      grouped[store].dates[date].CantidadDoc += group.CantidadDoc;
      grouped[store].totalDocs += group.CantidadDoc;
    });
    
    return Object.values(grouped).map(store => ({
      ...store,
      dates: Object.values(store.dates).sort((a, b) => new Date(b.date) - new Date(a.date))
    }));
  };

  const isToday = (dateString) => {
    if (!dateString) return false;
    const date = new Date(dateString);
    const today = new Date();
    return date.toDateString() === today.toDateString();
  };

  // Componente para el contador regresivo
  const CountdownTimer = () => {
    if (nextExecutionTime <= 0) return null;

    return (
      <Box 
        display="flex" 
        alignItems="center" 
        gap={1} 
        p={1} 
        bgcolor="#f5f5f5" 
        borderRadius={1}
        marginBottom={2}
      >
        <AccessTimeIcon color="primary" fontSize="small" />
        <Typography variant="body2" color="textSecondary">
          Próxima actualización en:
        </Typography>
        <Typography 
          variant="body2" 
          fontWeight="bold" 
          color={nextExecutionTime <= 3 ? "error" : "primary"}
        >
          {nextExecutionTime}s
        </Typography>
      </Box>
    );
  };

  const renderGroups = () => {
    try {
      const DG = JSON.parse(jsonData.datos_Generados);
      const groups = DG.Resultado || [];
      
      if (groups.length === 0) {
        return (
          <Paper elevation={3} style={{ padding: '20px', margin: '20px' }}>
            <Typography>No hay facturas pendientes para el rango de fechas seleccionado.</Typography>
          </Paper>
        );
      }
      
      const storesData = groupByStoreAndDate(groups);
      const today = new Date();
      
      // Filtrar items que no son del día actual y sin error para el "Seleccionar todos"
      const allItems = storesData.flatMap(store => 
        store.dates.flatMap(dateGroup => 
          dateGroup.Detalle.filter(item => {
            const itemDate = new Date(item.DocDate || item.fecha);
            return itemDate.toDateString() !== today.toDateString() && hasNoError(item);
          })
        )
      );
      
      const allSelected = storesData.length > 0 && allItems.every(item => 
        selectedItems.some(selected => selected.TransId === item.TransId)
      );

      return (
        <>
          <Box display="flex" alignItems="center" mb={2}>
            <Checkbox
              checked={allSelected && storesData.length > 0}
              onChange={() => handleSelectAll(storesData)}
            />
            <Typography variant="subtitle2">
              Seleccionar todos (excluyendo facturas del día actual y con error)
            </Typography>
          </Box> 

          {duplicateAlert && (
            <Alert severity="info" sx={{ mb: 2 }}>
              Esta factura ya ha sido seleccionada. No se permiten duplicados.
            </Alert>
          )}

          {storesData.map((store, storeIndex) => {
            const storeKey = `store-${store.storeName}-${storeIndex}`;
            const storeItems = store.dates.flatMap(dateGroup => 
              dateGroup.Detalle.filter(item => {
                const itemDate = new Date(item.DocDate || item.fecha);
                return itemDate.toDateString() !== today.toDateString() && hasNoError(item);
              })
            );
            
            const allInStoreSelected = storeItems.every(item => 
              selectedItems.some(selected => selected.TransId === item.TransId)
            );

            return (
              <Accordion
                key={storeKey}
                expanded={expandedStore === storeKey}
                onChange={handleStoreAccordionChange(storeKey)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`${storeKey}-content`}
                  id={`${storeKey}-header`}
                >
                  <Box display="flex" alignItems="center" width="100%" justifyContent="space-between">
                    <Box display="flex" alignItems="center">
                      <Box ml={2}>
                        <Typography variant="subtitle1">
                          <strong>{store.storeName}</strong>
                        </Typography>
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="center" gap={2}>
                      <Chip
                        label={`${store.totalDocs} documento(s)`}
                        color="primary"
                        size="small"
                      />
                    </Box>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Box>
                    {store.dates.map((dateGroup, dateIndex) => {
                      const dateKey = `date-${store.storeName}-${dateGroup.date}-${dateIndex}`;
                      const isDateToday = isToday(dateGroup.date);
                      
                      // Filtrar items que no son del día actual y sin error
                      const filteredItems = isDateToday ? [] : dateGroup.Detalle.filter(hasNoError);
                      
                      const allInDateSelected = filteredItems.every(item => 
                        selectedItems.some(selected => selected.TransId === item.TransId)
                      );

                      return (
                        <Accordion
                          key={dateKey}
                          expanded={expandedDate === dateKey}
                          onChange={handleDateAccordionChange(dateKey)}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`${dateKey}-content`}
                            id={`${dateKey}-header`}
                          >
                            <Box display="flex" alignItems="center" width="100%" justifyContent="space-between">
                              <Box display="flex" alignItems="center">
                                {!isDateToday && filteredItems.length > 0 && (
                                  <Checkbox
                                    checked={filteredItems.length > 0 && allInDateSelected}
                                    onChange={(e) => {
                                      e.stopPropagation();
                                      handleToggleAllGroupItems(dateGroup.Detalle);
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                    indeterminate={
                                      filteredItems.some(item => 
                                        selectedItems.some(selected => selected.TransId === item.TransId)
                                      ) && !allInDateSelected
                                    }
                                  />
                                )}
                                <Box ml={2}>
                                  <Typography variant="subtitle1">
                                    {formatDate(dateGroup.date)}
                                    {isDateToday && ' (Hoy - No seleccionable)'}
                                  </Typography>
                                </Box>
                              </Box>
                              <Box display="flex" alignItems="center" gap={2}>
                                <Chip
                                  label={`${dateGroup.CantidadDoc} documento(s)`}
                                  color="secondary"
                                  size="small"
                                />
                              </Box>
                            </Box>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Box>
                              <TableContainer component={Paper}>
                                <Table size="small" aria-label="detalle de documentos">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell padding="checkbox"></TableCell>
                                      <TableCell><strong>Número de Documento</strong></TableCell>
                                      <TableCell><strong>DocEntryFact</strong></TableCell>
                                      <TableCell><strong>TransId</strong></TableCell>
                                      <TableCell><strong>Error en Factura</strong></TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {dateGroup.Detalle.map((item, itemIndex) => {
                                      const isItemToday = isToday(item.DocDate || item.fecha);
                                      const isDuplicateItem = isDuplicate(item, selectedItems);
                                      const itemHasError = !hasNoError(item);
                                      const isSelectable = !isItemToday && !itemHasError;
                                      
                                      return (
                                        <TableRow key={`${item.TransId}-${itemIndex}`}>
                                          <TableCell padding="checkbox">
                                            {isSelectable ? (
                                              <Checkbox
                                                checked={selectedItems.some(selected => selected.TransId === item.TransId)}
                                                onChange={() => handleSelectItem(item)}
                                                disabled={isDuplicateItem && !selectedItems.some(selected => selected.TransId === item.TransId)}
                                              />
                                            ) : (
                                              <span></span>
                                            )}
                                          </TableCell>
                                          <TableCell>
                                            {item.DocNum}
                                            {isItemToday && ' (Hoy)'}
                                            {/* {itemHasError && ' (Con error)'}
                                            {isDuplicateItem && selectedItems.some(selected => selected.TransId === item.TransId) && ' (Seleccionada)'} */}
                                          </TableCell>
                                          <TableCell>{item.DocEntryFact}</TableCell>
                                          <TableCell>{item.TransId}</TableCell>
                                          <TableCell>{item.ErrorMsg || 'Sin error'}</TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Box>
                          </AccordionDetails>
                        </Accordion>
                      );
                    })}
                  </Box>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </>
      );
    } catch (e) {
      return (
        <Paper elevation={3} style={{ padding: '20px', margin: '20px', backgroundColor: '#ffebee' }}>
          <Typography color="error">Error al procesar los datos: {e.message}</Typography>
        </Paper>
      );
    }
  };

  const renderProcessResults = () => {
    if (processResults.length === 0 && batchStatus !== 'processing') return null;

    return (
      <Paper elevation={3} style={{ padding: '20px', marginTop: '20px' }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6" gutterBottom>
            Resultados del Procesamiento
          </Typography>
          {batchStatus === 'processing' && (
            <Box display="flex" alignItems="center">
              <CircularProgress size={20} style={{ marginRight: '8px' }} />
              <Typography variant="body2">Actualizando cada 10 segundos...</Typography>
            </Box>
          )}
          {trackingId && (
            <Typography variant="body2">
              <strong>ID de seguimiento:</strong> {trackingId}
            </Typography>
          )}
          {pendingGuides.length > 1 && (
            <Typography variant="body2">
              <strong>Guide {currentGuideIndex + 1} de {pendingGuides.length}</strong>
            </Typography>
          )}
        </Box>
        
        <CountdownTimer />
        
        {bitacoraData.length > 0 ? (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {/* <TableCell width="50px"></TableCell> */}
                  <TableCell>Documento</TableCell>
                  <TableCell>Estado</TableCell>
                  <TableCell>Mensaje</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {bitacoraData.map((result, index) => (
                  <React.Fragment key={index}>
                    <TableRow>
                      {/* <TableCell>
                        <IconButton
                          aria-label="expand row"
                          size="small"
                          onClick={() => toggleRowExpand(result.docNum)}
                        >
                          {expandedRows[result.docNum] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                      </TableCell> */}
                      <TableCell>{result.docNum}</TableCell>
                      <TableCell>
                        {result.success ? (
                          <Chip label="Éxito" color="success" size="small" />
                        ) : result.warning ? (
                          <Chip label="Advertencia" color="warning" size="small" />
                        ) : (
                          <Chip label="Error" color="error" size="small" />
                        )}
                      </TableCell>
                      <TableCell>
                        {result.error || result.mensaje || 'Procesado correctamente'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      {/* <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                        <Collapse in={expandedRows[result.docNum]} timeout="auto" unmountOnExit>
                          <Box margin={1}>
                            <Typography variant="subtitle2" gutterBottom>
                              Detalles del proceso
                            </Typography>
                            <Table size="small" aria-label="detalles">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Fecha</TableCell>
                                  <TableCell>Código</TableCell>
                                  <TableCell>Cliente</TableCell>
                                  <TableCell>Referencia</TableCell>
                                  <TableCell>Mensaje</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {result.bitacora.map((log, logIndex) => (
                                  <TableRow key={logIndex}>
                                    <TableCell>{log.Descripcion?.split('|')[0] || '-'}</TableCell>
                                    <TableCell>{log.Descripcion?.split('|')[1] || '-'}</TableCell>
                                    <TableCell>{log.Descripcion?.split('|')[2] || '-'}</TableCell>
                                    <TableCell>{log.NumeroReferencia || '-'}</TableCell>
                                    <TableCell>{log.Resultado || '-'}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Box>
                        </Collapse>
                      </TableCell> */}
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : batchStatus === 'processing' ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="100px">
            <CircularProgress />
            <Typography variant="body2" sx={{ ml: 2 }}>
              Esperando resultados del procesamiento...
            </Typography>
          </Box>
        ) : null}
      </Paper>
    );
  };

  return (
    <div style={{ padding: '20px' }}>
      <Typography variant="h4" gutterBottom>
        Facturas Pendientes
      </Typography>

      <Box display="flex" gap={2} alignItems="center" mb={3}>
        <TextField
          label="Fecha Inicio"
          type="date"
          value={fechaIni}
          onChange={(e) => setFechaIni(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          fullWidth
        />

        <TextField
          label="Fecha Fin"
          type="date"
          value={fechaFin}
          onChange={(e) => setFechaFin(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          fullWidth
        />

        <Button
          variant="contained"
          color="primary"
          onClick={fetchData}
          disabled={loading}
          style={{ height: '56px', minWidth: '120px' }}
        >
          {loading ? <CircularProgress size={24} /> : 'Buscar'}
        </Button>
      </Box>

      {loading && (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
          <CircularProgress />
        </Box>
      )}

      {error && (
        <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px', backgroundColor: '#ffebee' }}>
          <Typography color="error">Error: {error}</Typography>
          <Button variant="contained" color="primary" onClick={fetchData} style={{ marginTop: '10px' }}>
            Reintentar
          </Button>
        </Paper>
      )}

      {!loading && !error && jsonData && (
        <>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="subtitle1">
              Total de tiendas: {jsonData.Resultado?.reduce((acc, curr) => {
                const stores = new Set();
                stores.add(curr.Sala);
                return acc + stores.size;
              }, 0) || 0}
            </Typography>
            
            <Box display="flex" gap={2}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleValidateStock}
                startIcon={validating ? <CircularProgress size={24} color="inherit" /> : <CheckCircleIcon />}
              >
                Validar Existencias
              </Button>
              
              <Button
                variant="contained"
                color="primary"
                onClick={handleReprocess}
                disabled={selectedItems.length === 0 || processing || validating}
                startIcon={processing ? <CircularProgress size={24} color="inherit" /> : <DeleteIcon />}
              >
                {`Reprocesar (${selectedItems.length})`}
              </Button>
            </Box>
          </Box>

          {renderGroups()}
          {renderProcessResults()}
          
          {/* Contador para la tabla de bitácora */}
          {batchStatus === 'processing' && (
            <CountdownTimer />
          )}
          
          {/* <BitacoraTable 
            data={bitacoraData} 
            onRefresh={() => trackingId && fetchBitacoraData(trackingId)} 
            loading={bitacoraLoading}
          /> */}
        </>
      )}

      {/* Diálogo de procesamiento */}
      <Dialog open={showProcessingAlert} onClose={() => setShowProcessingAlert(false)}>
        <DialogTitle>Procesamiento Iniciado</DialogTitle>
        <DialogContent>
          <Typography>
            El procesamiento se ha iniciado correctamente. El sistema actualizará el estado automáticamente cada 10 segundos.
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            ID de seguimiento: <strong>{trackingId}</strong>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowProcessingAlert(false)} color="primary">
            Entendido
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FacturasPendientes;